import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgxFileDropComponent, NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';
import { SHARED_MODULES } from '../../../shared.';
import { PhIconComponent } from '../ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
	imports: [SHARED_MODULES, NgxFileDropModule, PhIconComponent, PhIconWrapperComponent],
    standalone: true
})
export class FileUploadComponent {

	@Input() acceptFormats: string = '.xlsx,.xls';
	@Input() multiple: boolean = false;
	@Input() primaryText: string = 'PRESS_OR_DRAG';
	@Input() secondaryText: string;

	@Output() onFileDrop: EventEmitter<Array<NgxFileDropEntry>> = new EventEmitter<Array<NgxFileDropEntry>>();
	@Output() onFileRemove: EventEmitter<void> = new EventEmitter<void>();

	fileName: string = '';

	@ViewChild(NgxFileDropComponent) ngxFileDropComponent: NgxFileDropComponent;

	fileDrop(event: Array<NgxFileDropEntry>): void {
		if (event && event.length > 0) {
			this.removeFile();
			this.fileName = event[0].fileEntry.name;
			this.onFileDrop.emit(event);
		}
	}

	removeFile(): void {
		this.fileName = '';
		this.onFileRemove.emit();
	}

	openFileSelectorProgrammatically(): void {
		if (this.ngxFileDropComponent && (this.ngxFileDropComponent as any).openFileSelector) {
			(this.ngxFileDropComponent as any).openFileSelector();
		}
	}
}